import { render, staticRenderFns } from "./listqueries.vue?vue&type=template&id=0d8d5a9f&scoped=true"
import script from "./listqueries.vue?vue&type=script&lang=js"
export * from "./listqueries.vue?vue&type=script&lang=js"
import style0 from "./listqueries.vue?vue&type=style&index=0&id=0d8d5a9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d5a9f",
  null
  
)

export default component.exports